export default {
  "brand.name": "USFansSheet",
  "brand.tagline": "Spreadsheet Hub",

  "nav.spreadsheet": "Spreadsheet",
  "nav.finds": "Znaleziska",
  "nav.guides": "Poradniki",
  "nav.reviews": "Opinie",
  "nav.shipping": "Wysyłka",
  "nav.coupons": "Kupony",
  "nav.warehouse": "Magazyn",
  "nav.safety": "Bezpieczeństwo",
  "nav.faq": "FAQ",
  "nav.home": "Strona główna",
  "nav.buyingGuide": "Poradnik zakupowy",
  "mobile.categories": "Przeglądaj kategorie",

  "hero.badge": "Zaktualizowane zasoby 2026",
  "hero.title": "USFans Spreadsheet — Szukaj mądrzej, kupuj pewniej",
  "hero.subtitle": "Mądrzejszy sposób na odkrywanie znalezisk USFans. Uporządkowane arkusze, linki W2C, poradniki produktowe, wskazówki QC, informacje o wysyłce i zasoby zakupowe — wszystko w jednym miejscu.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "kup teraz",
  "hero.trust": "Zaktualizowane zasoby · Poradniki zakupowe · Edukacja QC · Informacje o wysyłce",

  "stats.resources": "Zasoby",
  "stats.categories": "Kategorie",
  "stats.guides": "Poradniki",
  "stats.languages": "Języki",

  "dropdown.label": "Przeglądaj kategorie",
  "dropdown.placeholder": "Wybierz kategorię do przeglądania",

  "categories.title": "Kategorie USFans Spreadsheet",
  "categories.subtitle": "Przejdź bezpośrednio do dowolnej kategorii w głównym sklepie — uporządkowane, aby szybciej porównywać oferty.",

  "category.shoes": "Buty",
  "category.hoodies": "Bluzy / Swetry",
  "category.tshirts": "T-shirty",
  "category.jackets": "Kurtki",
  "category.pants": "Spodnie / Szorty",
  "category.headwear": "Nakrycia głowy",
  "category.sets": "Zestawy",
  "category.underwear": "Bielizna / Majtki",
  "category.jersey": "Koszulki sportowe",
  "category.accessories": "Akcesoria",
  "category.bags": "Torby",
  "category.belts": "Paski",
  "category.perfumes": "Perfumy",
  "category.other": "Inne rzeczy",

  "articles.title": "Popularne poradniki USFans Spreadsheet",
  "articles.subtitle": "Oryginalne artykuły oparte na researchu, które pomogą Ci zrozumieć proces przed złożeniem zamówienia.",
  "articles.readMore": "Czytaj poradnik",
  "articles.viewAll": "Zobacz wszystkie poradniki",

  "article.1.title": "Czym jest USFans Spreadsheet? Kompletny poradnik 2026",
  "article.1.excerpt": "Przejrzyste wyjaśnienie, czym jest USFans Spreadsheet, jak działa i jak go używać do researchu produktów, porównywania ofert i zrozumienia QC przed zamówieniem.",

  "guides.title": "Poradniki i zasoby USFans",
  "guides.subtitle": "Poznaj tematy opinii, wysyłki, kuponów, magazynu i bezpieczeństwa przed zamówieniem.",
  "guides.learnMore": "Czytaj poradnik",
  "guides.1.title": "Opinia o USFans",
  "guides.1.desc": "Wyważone spojrzenie na proces zakupowy i co warto rozważyć.",
  "guides.2.title": "Koszt wysyłki USFans",
  "guides.2.desc": "Zrozum wagę, linie i kraj docelowy przed wysyłką.",
  "guides.3.title": "Kupon USFans",
  "guides.3.desc": "Znajdź i zweryfikuj najnowsze kupony i rabaty.",
  "guides.4.title": "Kod rabatowy USFans",
  "guides.4.desc": "Jak działają kody rabatowe i na co uważać.",
  "guides.5.title": "Magazyn USFans",
  "guides.5.desc": "QC, przechowywanie i konsolidacja wyjaśnione prosto.",
  "guides.6.title": "Czy USFans jest legalne?",
  "guides.6.desc": "Kontrole bezpieczeństwa i sygnały ostrzegawcze do researchu.",
  "article.2.title": "Opinia USFans 2026 – Czy warto?",
  "article.2.excerpt": "Wyważona opinia o procesie zakupowym USFans – czego się spodziewać, zalety i uwagi oraz dla kogo sprawdza się najlepiej.",
  "article.3.title": "Poradnik kosztów wysyłki USFans 2026",
  "article.3.excerpt": "Jak obliczany jest koszt wysyłki USFans na podstawie wagi, linii i kraju docelowego oraz jak go oszacować i obniżyć.",
  "article.4.title": "Poradnik kuponów i kodów rabatowych USFans",
  "article.4.excerpt": "Gdzie znaleźć kupony i kody rabatowe USFans, jak zweryfikować ich aktualność i jakich błędów unikać.",
  "article.5.title": "Poradnik magazynu USFans 2026",
  "article.5.excerpt": "Jak magazyn USFans obsługuje QC, przechowywanie i konsolidację paczek przed wysyłką międzynarodową.",
  "article.6.title": "Czy USFans jest legalne w 2026?",
  "article.6.excerpt": "Wyważony poradnik bezpieczeństwa o ocenie sprzedawców, sygnałach ostrzegawczych i researchu przed zamówieniem.",
  "article.7.title": "Poradnik linków W2C USFans",
  "article.7.excerpt": "Czym jest W2C, jak działają linki W2C w arkuszu i jak bezpiecznie z nich korzystać.",
  "article.8.title": "Poradnik QC USFans – jak czytać zdjęcia QC",
  "article.8.excerpt": "Dowiedz się, co sprawdzać na zdjęciach QC – szwy, metki, kolor i proporcje – zanim przedmiot zostanie wysłany.",
  "article.9.title": "Poradnik zakupowy USFans 2026",
  "article.9.excerpt": "Poradnik krok po kroku obejmujący research, zamawianie, QC, płatność i wysyłkę we właściwej kolejności.",
  "article.10.title": "Jak korzystać z USFans Spreadsheet",
  "article.10.excerpt": "Przyjazny dla początkujących przewodnik po kategoriach i kolumnach arkusza oraz jak zamienić znaleziska w zamówienia.",
  "article.11.title": "Poradnik znalezisk USFans Spreadsheet",
  "article.11.excerpt": "Czym są znaleziska, najpopularniejsze kategorie i jak rozpoznać dobre, zanim się zdecydujesz.",

  "faq.title": "Najczęściej zadawane pytania",
  "faq.subtitle": "Szybkie odpowiedzi na temat USFans Spreadsheet i procesu zakupowego.",
  "faq.q1": "Czym jest USFans Spreadsheet?",
  "faq.a1": "USFans Spreadsheet to uporządkowane źródło researchu, które pomaga odkrywać produkty, porównywać oferty, sprawdzać dostępne informacje i rozumieć proces zakupowy przed złożeniem zamówienia.",
  "faq.q2": "Czy USFans jest legalne?",
  "faq.a2": "Dostarczamy zrównoważone informacje oparte na researchu, aby pomóc Ci samodzielnie ocenić sprzedawców i oferty. Zawsze weryfikuj aktualną ofertę, sprzedawcę i warunki wysyłki przed zakupem.",
  "faq.q3": "Jak działa USFans?",
  "faq.a3": "Zazwyczaj działa przez model agenta zakupowego lub forwardera: szukasz produktów, przesyłasz linki, sprawdzasz zdjęcia QC, a następnie organizujesz międzynarodową wysyłkę do swojego kraju.",
  "faq.q4": "Ile kosztuje wysyłka USFans?",
  "faq.a4": "Koszt wysyłki zależy od wagi paczki, wymiarów, linii wysyłkowej i kraju docelowego. Przed zamówieniem sprawdź poradnik wysyłki i aktualne stawki, ponieważ szacunki mogą się różnić.",
  "faq.q5": "Gdzie znajdę kupony USFans?",
  "faq.a5": "Dostępność kuponów i rabatów często się zmienia. Zawsze sprawdzaj najnowsze zweryfikowane oferty i ich daty wygaśnięcia, zanim na nich polegasz.",

  "safety.title": "Najpierw research. Potem zamówienie.",
  "safety.body": "Arkusz może pomóc w researchu produktów, ale żadna oferta nie gwarantuje jakości produktu, wiarygodności sprzedawcy, dostępności ani rezultatów wysyłki. Zawsze weryfikuj aktualne informacje przed zamówieniem.",

  "finalCta.title": "Gotowy, aby odkryć USFans?",
  "finalCta.body": "Przeglądaj arkusz, poznaj proces i przejdź do głównej strony, gdy będziesz gotowy.",
  "finalCta.button": "Odkryj zasoby USFans",

  "footer.resources": "Zasoby",
  "footer.company": "Firma",
  "footer.legal": "Prawne",
  "footer.language": "Język",
  "footer.about": "O nas",
  "footer.methodology": "Metodologia",
  "footer.editorial": "Polityka redakcyjna",
  "footer.contact": "Kontakt",
  "footer.privacy": "Prywatność",
  "footer.terms": "Warunki",
  "footer.disclaimer": "Zastrzeżenie",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.disclaimerText": "Informacje służą celom badawczym i edukacyjnym. Dostępność produktów, ceny i warunki wysyłki mogą się zmieniać. Zawsze weryfikuj aktualne informacje przed zakupem.",

  "article.meta": "Kompletny poradnik 2026 na temat USFans Spreadsheet — czym jest, jak działa i jak go używać do znalezisk, linków W2C, QC i wysyłki.",
  "article.backHome": "Wróć na stronę główną",
  "article.updated": "Ostatnia aktualizacja",
  "article.readTime": "min czytania",
  "article.toc": "Spis treści",
  "article.notFound": "Nie znaleziono artykułu",
  "article.related": "Chcesz przejrzeć uporządkowane kategorie? Wróć na stronę główną USFansSheet, aby przejrzeć pełną listę kategorii, lub przejdź do głównego sklepu poniżej.",
};